import { useSelector } from "react-redux";
import { useAppDispatch } from "components/shared/App";
import { StringIndexedObject } from "@kanda-libs/ks-design-library";
import { getQueryTerms } from "store/selectors/query";
import { type QueryType, setQuery } from "store/slices/query";

export type QueryHook = [string, (query: string) => void];

export default function useQuery(queryType: QueryType | ""): QueryHook {
  const dispatch = useAppDispatch();
  const query = useSelector(getQueryTerms);

  const onSetQuery = (nextQuery: string) => {
    dispatch(setQuery([queryType as QueryType, nextQuery]));
  };

  return [
    (query as StringIndexedObject)[queryType as QueryType] || "",
    onSetQuery,
  ];
}
